var map = {
	"./NLlog.png": 12,
	"./Team1.jpg": 13,
	"./cta-illustration.svg": 36,
	"./feature-tile-icon-01.svg": 37,
	"./feature-tile-icon-02.svg": 38,
	"./feature-tile-icon-03.svg": 39,
	"./feature-tile-icon-04.svg": 40,
	"./feature-tile-icon-05.svg": 41,
	"./feature-tile-icon-06.svg": 42,
	"./illustration-section-01.svg": 43,
	"./illustration-section-02.svg": 44,
	"./logo.svg": 45,
	"./modern-reader-1A.png": 46,
	"./modern-reader-2A.png": 47,
	"./modern-reader-3A.png": 48,
	"./modern-reader-4A.png": 49,
	"./video-placeholder.jpg": 50
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35;